import styled from "styled-components";

export const PageConfines = styled.div`
  width: 100%;
  margin: 0 auto;
  max-width: 1200px;
  padding: 0rem 1rem;
`;
